import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';
import 'bootswatch/dist/litera/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
